import { system, Config } from 'styled-system';

export type TextTransformProps = {
  textTransform?:
    | 'none'
    | 'capitalize'
    | 'uppercase'
    | 'lowercase'
    | 'initial'
    | 'inherit';
};

const config: Config = {
  textTransform: {
    property: 'textTransform',
  },
};

const textTransform = system(config);

export default textTransform;
